export default __webpack_public_path__ + "static/media/screen1.d4181833.jpg";